var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmanAppAdvertiseGoogleStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.403,
    height: 85,
    viewBox: "0 0 226.403 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1776",
    transform: "translate(-1276.781 -5186.652)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1956",
    width: 226,
    height: 85,
    fill: "#e1591f",
    rx: 11,
    transform: "translate(1276.781 5186.652)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Google_Store",
    transform: "translate(1297.792 -3377.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    fill: "#fff",
    d: "M218.006 1.7a6.394 6.394 0 0 1 4.981 2.611 10.24 10.24 0 0 1 2.063 6.3v63.674a10.24 10.24 0 0 1-2.063 6.3 6.394 6.394 0 0 1-4.981 2.611H8.385A6.394 6.394 0 0 1 3.4 80.588a10.239 10.239 0 0 1-2.063-6.3V10.612A10.237 10.237 0 0 1 3.4 4.309 6.393 6.393 0 0 1 8.385 1.7zm0-1.7H8.385a7.611 7.611 0 0 0-5.928 3.113A12.188 12.188 0 0 0 0 10.612v63.673a12.188 12.188 0 0 0 2.456 7.5A7.611 7.611 0 0 0 8.385 84.9h209.621a7.611 7.611 0 0 0 5.929-3.113 12.19 12.19 0 0 0 2.456-7.5V10.612a12.19 12.19 0 0 0-2.456-7.5A7.611 7.611 0 0 0 218.006 0z",
    opacity: 0.302,
    transform: "translate(-21 8564)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    transform: "translate(-4.282 8583.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    d: "M111.119 35.166a7.127 7.127 0 1 0 7.161 7.127 7.027 7.027 0 0 0-7.161-7.127zm0 11.461a4.327 4.327 0 1 1 4.026-4.327 4.126 4.126 0 0 1-4.026 4.327zM95.506 35.166a7.127 7.127 0 1 0 7.144 7.127 7.027 7.027 0 0 0-7.161-7.127zm0 11.461a4.327 4.327 0 1 1 4.009-4.327 4.126 4.126 0 0 1-4.026 4.327zm-18.6-9.265v3.018h7.245a6.322 6.322 0 0 1-1.677 3.806 7.413 7.413 0 0 1-5.583 2.214 8.05 8.05 0 1 1 0-16.1 7.714 7.714 0 0 1 5.484 2.166l2.125-2.131a10.548 10.548 0 0 0-7.59-3.133 11.085 11.085 0 1 0 0 22.154 9.79 9.79 0 0 0 10.346-10.179 9.84 9.84 0 0 0-.168-1.895zm75.982 2.347a6.594 6.594 0 0 0-12.812 2.582 6.977 6.977 0 0 0 7.075 7.127 7.1 7.1 0 0 0 5.943-3.152l-2.432-1.677a4.076 4.076 0 0 1-3.5 1.981 3.622 3.622 0 0 1-3.455-2.163l9.542-3.941zm-9.726 2.381a3.907 3.907 0 0 1 3.733-4.159 2.768 2.768 0 0 1 2.65 1.51zM135.416 49h3.133V28.039h-3.136zm-5.132-12.242h-.117a5.03 5.03 0 0 0-3.757-1.677 7.144 7.144 0 0 0 0 14.271 4.862 4.862 0 0 0 3.757-1.677h.1V48.7c0 2.734-1.459 4.192-3.806 4.192a3.941 3.941 0 0 1-3.588-2.533l-2.734 1.14a6.792 6.792 0 0 0 6.322 4.209c3.679 0 6.708-2.163 6.708-7.43V35.584h-2.885zm-3.584 9.86a4.344 4.344 0 0 1 0-8.654 4.026 4.026 0 0 1 3.806 4.327 3.992 3.992 0 0 1-3.82 4.327zm40.892-18.581h-7.5V49h3.136v-7.948h4.372a6.524 6.524 0 1 0 0-13.017zm0 10.062h-4.376v-7.143h4.444a3.6 3.6 0 0 1 0 7.195zm19.337-3.018a5.871 5.871 0 0 0-5.585 3.2l2.783 1.157a2.971 2.971 0 0 1 2.851-1.542 3.018 3.018 0 0 1 3.353 2.7v.218a6.933 6.933 0 0 0-3.27-.805c-3 0-6.038 1.677-6.038 4.712a4.848 4.848 0 0 0 5.2 4.611 4.412 4.412 0 0 0 4.026-2.012h.1V49h3.018v-8.073c0-3.679-2.783-5.8-6.356-5.8zm-.386 11.488c-1.023 0-2.448-.519-2.448-1.777 0-1.677 1.777-2.23 3.353-2.23a5.568 5.568 0 0 1 2.851.707 3.791 3.791 0 0 1-3.679 3.353zm17.828-10.984l-3.588 9.09h-.1l-3.723-9.09h-3.37l5.585 12.715L196 55.36h3.27l8.586-19.772zM176.175 49h3.136V28.039h-3.136z",
    className: "cls-3",
    transform: "translate(-13.572 -10.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    d: "M16.836 54.274l20.549-21.309-20.532-21.271a2.371 2.371 0 0 0-.887 2.1v38.4a2.417 2.417 0 0 0 .87 2.081z",
    className: "cls-3",
    transform: "translate(-15.953 -10.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    d: "M38.018 32.387l6.12-6.347-24.917-14.175a2.688 2.688 0 0 0-1.382-.388l20.179 20.907z",
    className: "cls-3",
    transform: "translate(-15.86 -10.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    d: "M38.025 32.551l-20.244 21a2.671 2.671 0 0 0 1.446-.4L44.2 38.941z",
    className: "cls-3",
    transform: "translate(-15.861 -9.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    d: "M52.218 30.494l-8.293-4.726-6.287 6.521 6.333 6.563 8.243-4.713a1.921 1.921 0 0 0 0-3.645z",
    className: "cls-3",
    transform: "translate(-14.907 -10.189)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\u0645\\u062A\\u0648\\u0641\\u0631_\\u0639\\u0644\\u0649",
    fill: "#fff",
    fontFamily: "HelveticaNeueLTArabic-Bold, Helvetica Neue Arabic",
    fontSize: "14px",
    fontWeight: 700,
    transform: "translate(1376.781 5214.652)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.665,
    y: 0
  }, "\u0645\u062A\u0648\u0641\u0631 \u0639\u0644\u0649")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmanAppAdvertiseGoogleStore);
export default __webpack_public_path__ + "static/media/amanApp-advertise-google-store.b0cb0ce70c65094156274030944220e9.svg";
export { ForwardRef as ReactComponent };